/* eslint-disable react/destructuring-assignment */
import { DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { kiraB50Thumbnail } from 'assets/images';
import { BaseCheckbox } from 'components/UI/BaseCheckbox';
import { getMachineType } from 'util/machine-type';

export const renderColumns = (
  t,
  onDeleteOperator,
  setEmailPhoneFieldsRowData,
  editableFieldsOfRowIds,
  emailPhoneFieldsRowData
) => [
  {
    width: 80,
    title: '',
    dataIndex: 'machine',
    render: (machine) => {
      if (machine) {
        const { thumbnail, type } = machine;
        return (
          <img
            width={80}
            height="auto"
            src={thumbnail || kiraB50Thumbnail}
            alt={type}
          />
        );
      }
      return (
        <img
          width={80}
          height="auto"
          src={kiraB50Thumbnail}
          alt="machine-kira"
        />
      );
    }
  },
  {
    width: 250,
    title: t('operatorTable.columns.machineName'),
    dataIndex: 'machine',
    render: (machine) => {
      if (machine) {
        const { materialNumber, alias } = machine;

        return (
          <>
            <span className="text-lg uppercase bold">
              {getMachineType(materialNumber)}
            </span>
            <div>{t('operatorTable.columns.machineAlias', { alias })}</div>
          </>
        );
      }
      return null;
    }
  },
  {
    width: 250,
    title: t('operatorTable.columns.operatorName'),
    dataIndex: 'name',
    render: (name, row) => {
      return (
        <>
          <span className="uppercase bold">
            {t(`rolesMapping.${row.role}`)}
          </span>
          <div>{name}</div>
        </>
      );
    }
  },
  {
    width: 250,
    title: t('operatorTable.columns.operatorEmail'),
    dataIndex: 'email',
    render: (email, row) => {
      return (
        <BaseCheckbox
          disabled={!editableFieldsOfRowIds?.includes(row.id)}
          onClick={(e) =>
            setEmailPhoneFieldsRowData({
              ...emailPhoneFieldsRowData,
              [row.id]: {
                ...emailPhoneFieldsRowData[row.id],
                isEmailNotified: e.target.checked
              }
            })
          }
          checked={row?.isEmailNotified}>
          {email}
        </BaseCheckbox>
      );
    }
  },
  {
    width: 250,
    title: t('operatorTable.columns.operatorPhone'),
    dataIndex: 'phoneNumber',
    render: (phoneNumber, row) => {
      return (
        <BaseCheckbox
          disabled={!editableFieldsOfRowIds?.includes(row.id)}
          onClick={(e) =>
            setEmailPhoneFieldsRowData({
              ...emailPhoneFieldsRowData,
              [row.id]: {
                ...emailPhoneFieldsRowData[row.id],
                isPhoneNotified: e.target.checked
              }
            })
          }
          checked={row?.isPhoneNotified}>
          {phoneNumber?.replace(/\./g, '')}
        </BaseCheckbox>
      );
    }
  },
  {
    width: 150,
    title: '',
    dataIndex: 'actions',
    render: (actions, row) => {
      return (
        <div className="display-flex">
          <Button
            type="text"
            className="mx-4"
            icon={<DeleteOutlined onClick={() => onDeleteOperator(row)} />}
          />
        </div>
      );
    }
  }
];
